//
//
//

import React, { useState } from "react";
import { Routes, Route, useNavigate } from 'react-router-dom';

import { Row, Col, Button, Table } from "react-bootstrap";

import CanadaPayrollCalc from "./Calculators/CanadaPayrollCalc";
import CanadaPayRequired from "./Calculators/CanadaPayRequired";
import CarCalculator from "./Calculators/CarCalculator";
import MortgageAnalyzer from "./Calculators/MortgageAnalyzer";

import getPCPUrl from "../../components/pcpUrl";



function CalculatorPanel(props) {
  const root_url = getPCPUrl();
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();


  const fetchData = async (method, endpoint, body) => {
    let url = root_url + endpoint;

    let results = {
      status: -1,
      body: null
    };

    setErrorMsg('');
    setIsLoading(true);

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(body)
      });

      results.status = response.status;
      if (results.status >= 200 && results.status <= 299) {
        results.body = await response.json();
      }
      //response.status
      //response.statusText 
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setErrorMsg(err.message);
    }


    return results;
  }




  const submitRequest = async (url, request) => {

    let results = await fetchData("POST", url, request);

    return results;
  }


  function onCancel(event) {
    event.preventDefault();

    navigate(-1);
  }


  const div_style = {
    "fontSize": "0.8em"
  };


  return (
    <>

      <Row style={div_style}> 

        <Col lg={{ span: 6, offset: 3 }}>

          {(errorMsg.length > 0) && <Row><Col><h5>ERROR: {errorMsg}</h5></Col></Row>}

          {isLoading && <Row><Col><h5>Executing</h5></Col></Row>}

          <Row>

            <Col>

              <Routes>

                <Route path="canadapay" element={<CanadaPayrollCalc submitRequest={submitRequest} onCancel={onCancel} />} />
                <Route path="canadapayreq" element={<CanadaPayRequired submitRequest={submitRequest} onCancel={onCancel} />} />

                <Route path="carcalc" element={<CarCalculator  submitRequest={submitRequest} onCancel={onCancel} />} />
                <Route path="mortgage" element={<MortgageAnalyzer />} />

                <Route path="*" element={<h4>Eeekk</h4>} />

              </Routes>

            </Col>

          </Row>
        </Col>
      </Row>

    </>

  );
}


export default CalculatorPanel;

